import { CompositeFilterDescriptor } from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";
import { State } from "@progress/kendo-data-query";

export function concatFilter(filter: CompositeFilterDescriptor, currentDataState: State) {
  let currentFilter = currentDataState.filter;

  if (!currentFilter) {
    return filter;
  }

  if (currentFilter.logic !== "and") {
    currentFilter = {
      logic: "and",
      filters: [currentFilter, filter],
    };
  } else if (currentFilter.filters) {
    currentFilter.filters.push(filter);
  } else {
    currentFilter.filters = [filter];
  }
  return currentFilter;
}
